module.exports = __webpack_public_path__ + "img/ring_0_0_null_1@3x.b1a85145.png";